
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import EmployeeDocumentSerializer from '../types/EmployeeDocumentSerializer_users'


const HOST = `${config.API_HOST}`
/* ['generics.ListCreateAPIView'] */
/* params:  */
/* data:  */
const EmployeeDocumentListCreateAPI :
{
  list:     ({employee_id, params, apiToken, extra}:
             { employee_id: any,
                params?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
  create:   ({employee_id, params, data, apiToken, extra}:
             { employee_id: any,
                params?: any,
                data?: EmployeeDocumentSerializer,
                apiToken?: any,
                extra?: any
            }) => any,
} =
{
  list: async ({employee_id, params, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers["device"] = extra.device;
    const result = await to(base.client.get(`${HOST}/users/apis/employee/${employee_id}/document/`,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },

  create: async ({employee_id, params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers["Authorization"] = "Token " + apiToken;
      base.client.defaults.headers["content-type"] = "multipart/form-data";
    if (extra?.division)
      base.client.defaults.headers["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers["device"] = extra.device;
    const formData = new FormData();
    for (const [key, value] of Object.entries(data || {})) {
      formData.append(key, value);
    }
    const result = await to(base.client.post(`${HOST}/users/apis/employee/${employee_id}/document/`,
      { ...data
      },
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default EmployeeDocumentListCreateAPI

